/**
 * Manages visual snap line indicators displayed during element dragging.
 * Creates and controls horizontal/vertical guide lines that appear when
 * elements snap to other elements.
 */
export default class SnapLineManager {
  /**
   * @param {HTMLElement} canvasElement - The canvas container where snap lines will be appended
   */
  constructor(canvasElement) {
    this.canvasElement = canvasElement;
    this.verticalLine = null;
    this.horizontalLine = null;
    this._createSnapLines();
  }

  _createSnapLines() {
    this.verticalLine = document.createElement('div');
    this.verticalLine.classList.add('snap-line', '-vertical', 'hidden');
    this.canvasElement.appendChild(this.verticalLine);

    this.horizontalLine = document.createElement('div');
    this.horizontalLine.classList.add('snap-line', '-horizontal', 'hidden');
    this.canvasElement.appendChild(this.horizontalLine);
  }

  /**
   * Shows element-to-element snap lines based on the snap result.
   * Snap lines are not shown for canvas snaps (centerline and edges) since those are always visible.
   * @param {Object} snapResult - Result from SnapHelper.snap()
   */
  updateSnapLines(snapResult) {
    this.hideAllSnapLines();

    if (snapResult.snappedHorizontal && !snapResult.snappedHorizontal.type.startsWith('canvas-')) {
      this.verticalLine.style.left = snapResult.snappedHorizontal.position + 'px';
      this.verticalLine.classList.remove('hidden');
    }

    if (snapResult.snappedVertical && !snapResult.snappedVertical.type.startsWith('canvas-')) {
      this.horizontalLine.style.top = snapResult.snappedVertical.position + 'px';
      this.horizontalLine.classList.remove('hidden');
    }
  }

  hideAllSnapLines() {
    this.verticalLine.classList.add('hidden');
    this.horizontalLine.classList.add('hidden');
  }
}
